(function() {
  'use strict';
  window._learnq = window._learnq || [];
  var _learnq = window._learnq;

  function getUserIdentifier() {
    // 1. Prioridad: El email que pasamos desde theme.liquid
    if (window.KlaviyoCustomer && window.KlaviyoCustomer.email) {
      return { type: '$email', value: window.KlaviyoCustomer.email };
    }
    
    // 2. Segunda opción: El ID de Shopify (convertido a String para evitar errores)
    if (window.KlaviyoCustomer && window.KlaviyoCustomer.id) {
      return { type: '$id', value: String(window.KlaviyoCustomer.id) };
    }

    // 3. Tercera opción: ID anónimo
    var anonymousId = localStorage.getItem('klaviyo_anonymous_id');
    if (!anonymousId) {
      anonymousId = 'anon_' + Date.now();
      localStorage.setItem('klaviyo_anonymous_id', anonymousId);
    }
    return { type: '$anonymous', value: anonymousId };
  }

  function trackAddToCart() {
    fetch(`${window.location.origin}/cart.js`)
      .then(res => res.json())
      .then(data => {
        if (!data.items || data.items.length === 0) return;

        var user = getUserIdentifier();
        
        // Identificar al usuario en Klaviyo
        var identifyObject = {};
        identifyObject[user.type] = user.value;
        _learnq.push(['identify', identifyObject]);

        var eventData = {
          '$value': data.total_price / 100,
          'ItemNames': data.items.map(item => item.product_title),
          'CheckoutURL': window.location.origin + '/checkout',
          'Items': data.items.map(item => ({
            'ProductID': item.product_id,
            'SKU': item.sku,
            'ProductName': item.product_title,
            'Quantity': item.quantity,
            'ItemPrice': item.price / 100,
            'RowTotal': item.line_price / 100,
            'ProductURL': window.location.origin + item.url,
            'ImageURL': item.image
          }))
        };

        _learnq.push(['track', 'Added to Cart', eventData]);
        console.log(eventData)
        console.log("✅ Added to Cart enviado para:", user.value);
      });
  }

  // Interceptores de tráfico (Fetch y XHR)
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function() {
      const url = arguments[0];
      const response = originalFetch.apply(this, arguments);
      if (typeof url === 'string' && url.includes('/cart/add')) {
        response.then(() => setTimeout(trackAddToCart, 1000));
      }
      return response;
    };
  }
})();